import {
  Button, Form, Input, InputNumber, Space, Upload,
} from 'antd';
import { UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
import useTranslation from '../../../hooks/translation/useTranslation';

function AddCountry() {
  const { trans } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [fileList, setFileList] = useState([]);

  const onFinish = (values) => {
    setIsLoading(true);

    const formData = new FormData();
    Object.keys(values).map((key) => values?.[key] && formData.append(key, values?.[key]));
    // eslint-disable-next-line no-unused-expressions
    fileList
     && values?.flag_image?.file
      ? formData.set('flag_image', values?.flag_image?.file)
      : formData.delete('flag_image');

    axios.post('/api/countries', formData).then((res) => {
      setIsLoading(false);
      if (res?.data?.status === 'success') {
        navigate('/admin/countries');
      } else {
        setErrors(res?.data?.errors);
      }
    }).catch((error) => {
      if (error.response?.data?.errors) {
        setIsLoading(false);
        setErrors(error.response?.data?.errors);
      }
    });
  };

  const beforeImageUpload = (file) => {
    if (
      file.type === 'image/jpeg'
      || file.type === 'image/jpg'
      || file.type === 'image/png'
      || file.type === 'image/svg'
      || file.type === 'image/svg+xml'
    ) {
      if (file.size / 1024 / 1024 < 0.5) {
        setFileList([{
          uid: '1',
          name: file?.name,
          status: 'done',
          url: URL.createObjectURL(file),
        }]);
        setErrors({ ...errors, flag_image: null });
      } else {
        setErrors({ ...errors, flag_image: 'სურათი უნდა იყოს 500kb ზომის' });
      }
    } else {
      setErrors({ ...errors, flag_image: 'სურათ უნდა იყოს .jpeg, .jpg, .png ან .svg გაფართოების' });
    }
    return false;
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/countries')}
      />
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          label={`${trans('country_name_geo')}*`}
          name="name_ka"
          validateStatus={errors?.name_ka && 'error'}
          help={errors?.name_ka}
        >
          <Input placeholder={trans('input_country_name_geo')} />
        </Form.Item>
        <Form.Item
          label={`${trans('country_name_en')}*`}
          name="name_en"
          validateStatus={errors?.name_en && 'error'}
          help={errors?.name_en}
        >
          <Input placeholder={trans('input_country_name_en')} />
        </Form.Item>
        <Form.Item
          label={`${trans('country_name_ru')}*`}
          name="name_ru"
          validateStatus={errors?.name_ru && 'error'}
          help={errors?.name_ru}
        >
          <Input placeholder={trans('input_country_name_ru')} />
        </Form.Item>

        <Form.Item
          name="flag_image"
          label={`${trans('country_flag')}*`}
          validateStatus={errors?.flag_image && 'error'}
          help={errors?.flag_image}
        >
          <Upload
            listType="picture"
            beforeUpload={beforeImageUpload}
            fileList={fileList}
            onRemove={() => setFileList(null)}
          >
            <Button icon={<UploadOutlined />}>{trans('choose_image')}</Button>
          </Upload>
        </Form.Item>
        <Form.Item
          name="country_phone_code"
          label={`${trans('country_phone_code')}*`}
          validateStatus={errors?.country_phone_code && 'error'}
          help={errors?.country_phone_code}
        >
          <InputNumber
            placeholder={trans('input_country_phone_code')}
            type="number"
            controls={false}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {trans('submit')}
          </Button>
        </Form.Item>
      </Form>
    </Space>
  );
}

export default AddCountry;
